var locale = {
    placeholder: 'Select time'
};
export default locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/time-picker/locale/en_US.js
// module id = 245
// module chunks = 0